import xray from 'lib/xray';

const getTariffsIds = (id: string, tariffNameSuffix: string): { monthTariffId: string; yearTariffId: string } => ({
    monthTariffId: `${id}1m_${tariffNameSuffix}`,
    yearTariffId: `${id}1y_${tariffNameSuffix}`,
});

export const prepareTariffsList = (tariffs, quotaLandingTariffsConfig) => {
    const { tariffsIds, tariffNameSuffix, recommendedId } = quotaLandingTariffsConfig;

    if (Object.entries(tariffs).length === 0) {
        xray.send('quota_tar_list_no_tariffs');
        return [];
    }

    return tariffsIds
        .map((id) => {
            if (id === 'base') {
                const space = {
                    space: 8,
                    units: 'ГБ',
                };

                return {
                    id,
                    isSelected: false,
                    isBase: true,
                    yearSpace: space,
                    monthSpace: space,
                };
            }

            const { monthTariffId, yearTariffId } = getTariffsIds(id, tariffNameSuffix);

            const yearTariff = tariffs[yearTariffId];
            const monthTariff = tariffs[monthTariffId];

            if (!yearTariff || !monthTariff) {
                const radarSuffix = `${!yearTariff ? '_y' : ''}${!monthTariff ? '_m' : ''}`;
                xray.send(`quota_tar_list_no_tariff_${id}${radarSuffix}`);
                return null;
            }

            const { space: yearSpace, products: yearProducts } = yearTariff;
            const { space: monthSpace, products: monthProducts } = monthTariff;

            const yearPrice = yearProducts[0]?.price;
            const monthPrice = monthProducts[0]?.price;

            const saving = monthPrice * 12 - yearPrice;

            return {
                id,
                yearSpace,
                monthSpace,
                yearPrice,
                monthPrice,
                saving,
                isRecommended: id === recommendedId,
                isBase: false,
                monthTariffId,
                yearTariffId,
            };
        })
        .filter(Boolean);
};

const SCREEN_WIDTH_FOR_ONE_CARDS = 600;
const SCREEN_WIDTH_FOR_TWO_CARDS = 800;
const SCREEN_WIDTH_FOR_THREE_CARDS = 1300;

export const carouselBreakpoints = [
    {
        maxWidth: SCREEN_WIDTH_FOR_ONE_CARDS,
        showCount: 1,
    },
    {
        maxWidth: SCREEN_WIDTH_FOR_TWO_CARDS,
        showCount: 2,
    },
    {
        maxWidth: SCREEN_WIDTH_FOR_THREE_CARDS,
        showCount: 3,
    },
];
